"use client";

import React from "react";
import { FormField, FormItem, FormLabel, FormControl, FormDescription, FormMessage } from "@/components/ui/form";
import { Textarea } from "@/components/ui/textarea";
import { Control } from "react-hook-form";
import type { MeetingFormValues } from "../../types/meeting-form";

interface MeetingNotesProps {
  control: Control<MeetingFormValues>;
  isSubmitting: boolean;
}

export const MeetingNotes: React.FC<MeetingNotesProps> = ({ control, isSubmitting }) => {
  return (
    <FormField
      control={control}
      name="notes"
      render={({ field }) => (
        <FormItem>
          <FormLabel>Meeting Notes</FormLabel>
          <FormControl>
            <Textarea
              placeholder="What was discussed? Key decisions, action items, outcomes..."
              className="min-h-[120px] resize-y"
              {...field}
              disabled={isSubmitting}
            />
          </FormControl>
          <FormDescription>
            Summary of what was discussed and any action items
          </FormDescription>
          <FormMessage />
        </FormItem>
      )}
    />
  );
};
